import React from 'react'
import { Route, Routes } from 'react-router-dom'

import Companies from '@pages/companies'
import BeneficiaryInfos from '@pages/insurance/beneficiaryInfos'
import ProgrammeInfos from '@pages/insurance/programmeInfos'
import Login from '@pages/login'
import UploadExams from '@pages/uploadExams'
import LoansDetail from '@pages/loans'
import LoanConsentForm from '@pages/loanConsentForm'
import MessagesDetail from '@pages/messages'
import MessageInfos from '@pages/messages/messageInfos'
import ExamsImport from '@pages/examsImport'
import FaceRecognition from '@pages/faceRecognition'
import ActivitySchedule from '@pages/activitySchedule'

const InsuranceContainer = () => (
  <Routes>
    <Route element={<Login />} path="/" />
    <Route
      element={<Companies />}
      path="/empresas"
    />
    <Route
      element={<ProgrammeInfos />}
      path="/programas/:programmeId"
    />
    <Route
      element={<BeneficiaryInfos />}
      path="/empresas/:companyId"
    />
    <Route
      element={<BeneficiaryInfos />}
      path="/empresa/:companyName"
    />
    <Route
      element={<ProgrammeInfos />}
      path="/programa/:programmeName"
    />
    <Route
      element={<UploadExams />}
      path="/importar-exames/*"
    />
    <Route
      element={<ExamsImport />}
      path="/importacao-automatica"
    />
    <Route
      element={<LoansDetail />}
      path="/emprestimos/"
    />
    <Route
      element={<LoanConsentForm />}
      path="/emprestimos/termo-de-emprestimo/:loanId"
    />
    <Route element={<FaceRecognition />} path="controle-de-acesso" />
    <Route element={<ActivitySchedule />} path="agenda-de-atividades" />
    <Route
      element={<MessageInfos />}
      path="/mensagem/:messageId"
    />
    <Route
      element={<MessagesDetail />}
      path="/mensagens"
    />
    <Route
      element={<MessagesDetail />}
      path="/mensagens/programa/:programmeId"
    />
    <Route path="/mensagens" element={<MessagesDetail />}>
      <Route path="programa/:programmeId" element={<MessagesDetail />} />
      <Route path="empresa/:companyId" element={<MessagesDetail />} />
    </Route>

  </Routes>
)

export default InsuranceContainer
